module.exports = __webpack_public_path__ + "img/66_4.87a3b5f4.png";